import React from 'react';
import { bool, any } from 'prop-types';

const Hide = ({ condition, children }) => {
    if (!condition) return children;
    return (
        <div style={{ visibility: 'hidden', height: '0px' }}>
            { children }
        </div>
    );
};

Hide.propTypes = {
    condition: bool,
    children: any
};

Hide.defaultProps = {
    condition: false,
    children: null
};

export default Hide;
